import { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'
import { Image } from 'lib'

import Show_password from "assets/images/show_password.svg"
import LoginPage from 'components/LoginPage';
import './index.scss';

const SignIn = () => {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({})
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate()

  const setField = (field, value) => {
    setForm({ ...form, [field]: value })

    if (!!errors[field]) {
      setErrors({ ...errors, [field]: null })
    }
  }

  const validateForm = () => {
    const { username, password } = form;
    const newErrors = {}

    if (!username || username === '') newErrors.username = "Enter a valid email address"
    if (!password || password === '') newErrors.password = "Enter a valid password"

    return newErrors
  }

  const handleClickShowPassword = () => {
    setShowPassword(showPassword => !showPassword)
  }
  const handleRedirect = () => {
      navigate(`/dashboard/forgot-password`)
  }
  const onSubmitHandler = (e) => {
    e.preventDefault()
    const formErrors = validateForm()
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors)
    } else {
      // console.log("Form submitted", form)
    }
  }
  return (
    <LoginPage>
      <Form className='signin_container'>
        <p>Sign In</p>
        <Form.Group controlId='username'>
          <Form.Label>User Name</Form.Label>
          <Form.Control type="email" className="form-input" placeholder='Enter user name' onChange={e => setField('username', e.target.value)} value={form.username} isInvalid={!!errors.username}></Form.Control>
          <Form.Control.Feedback type='invalid'>{errors.username}</Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='login_card_password'>
          <Form.Label>Password</Form.Label>
          <Form.Control type={showPassword ? "text" : "password"} className="form-input" placeholder='Enter password' onChange={e => setField('password', e.target.value)} value={form.password} isInvalid={!!errors.password}></Form.Control>
          <Form.Control.Feedback type='invalid'>{errors.password}</Form.Control.Feedback>
          <Button className={errors.password ? "hide" : "show_password"} onClick={handleClickShowPassword}><Image imageSrc={Show_password} className="show_image" />Show password</Button>
          <Button className={errors.password ? "hide" : "forget_password"} onClick={handleRedirect}>Forgot password?</Button>
        </Form.Group>
        <Button className="login_button" onClick={onSubmitHandler}>LOGIN</Button>
      </Form>
    </LoginPage>
  )
}

export default SignIn